import Axios from "axios";

export const fetchRoadXmlFilesStart = () => ({
  type: "FETCH_ROAD_XML_FILES_START"
});

export const fetchRoadXmlFilesSuccess = (roadXmlFiles) => ({
  type: "FETCH_ROAD_XML_FILES_SUCCESS",
  payload: roadXmlFiles
});

export const fetchRoadXmlFilesFailure = (error) => ({
  type: "FETCH_ROAD_XML_FILES_FAILURE",
  payload: error
});
export const downloadRoadXmlFilesStart = (roadXmlFiles) => ({
  type: "DOWNLOAD_ROAD_XML_FILES_START",
  payload:roadXmlFiles
});

export const downloadRoadXmlFilesSuccess = (xmlFileData) => ({
  type: "DOWNLOAD_ROAD_XML_FILES_SUCCESS",
  payload: xmlFileData
});

export const downloadRoadXmlFilesFailure = (error) => ({
  type: "DOWNLOAD_ROAD_XML_FILES_FAILURE",
  payload: error
});

